const supervisor = {
    'TITLE': 'Giám sát viên',
    'SHIFT': 'Ca',
    'DATE': 'Ngày',
    'CAMPAIGN': 'Chiến dịch',
    'CREATED_AT': 'Tạo lúc',
    'CREATED_BY': 'Tạo bởi',
    'UPDATE_DATE': 'Ngày cập nhật',
    'UPDATE_BY': 'Cập nhật bởi',
    'FILTER': 'Bộ lọc',
    'DELETE': 'Xóa',
    'TITLE_CONF': 'Xóa giám sát viên',
    'MESSAGE': 'Bạn có chắc chắn muốn xóa giám sát viên này không?',
    'TITLE_EDIT': 'Chỉnh sửa thông tin giám sát viên',
};

export default supervisor;